/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VirtualArticleDiscrepanciesResponse } from '../../models/virtual-article-discrepancies-response';

export interface GetBundleGroupVirtualArticleDiscrepancies$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
}

export function getBundleGroupVirtualArticleDiscrepancies(http: HttpClient, rootUrl: string, params: GetBundleGroupVirtualArticleDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, getBundleGroupVirtualArticleDiscrepancies.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VirtualArticleDiscrepanciesResponse>;
    })
  );
}

getBundleGroupVirtualArticleDiscrepancies.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies';
